// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c893b74","453":"b4be1faa","667":"d9b24bec","701":"39a99288"}[chunkId] + ".chunk.js";
};